import { Card } from "@/components/ui/card";
import {
  DataTable,
  DateField,
  List,
  ListActions,
  NeutralBadge,
  SearchInput,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const HolidayList = () => (
  <List
    title="Holidays"
    filters={filters}
    actions={<ListActions label="Add Holiday" />}
    sort={{ field: "date", order: "ASC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="edit">
        <DataTable.Col source="date" label="Date">
          <DateField source="date" />
        </DataTable.Col>
        <DataTable.Col source="name" label="Holiday" className="font-semibold" />
        <DataTable.Col label="Type">
          <NeutralBadge source="type" />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);
